import { INKLE_WEBSITE_URL } from "../../constants/base";

export const TP_TOS = `${INKLE_WEBSITE_URL}tp-payments-terms-service`;
